import React, { useState, useEffect, useCallback } from 'react';
import { CATALOG } from '../../constants/catalog';
import { ILS } from '../../utils/salesUtils';

const SIZE_NAMES  = { S: 'Pequeño', M: 'Mediano', L: 'Grande', XL: 'Extra grande' };
const SIZE_RANGES = { S: '≤10.9 kg', M: '11–20 kg', L: '21–35 kg', XL: '>35 kg' };

export default function ItemPickerSheet({ dogSize, onClose, onAdd, catalog: catalogProp }) {
  const catalog = catalogProp || CATALOG;
  const [cat, setCat] = useState('daycare');
  const [size, setSize] = useState(['S', 'M', 'L', 'XL'].includes(dogSize) ? dogSize : 'M');
  const [otherName, setOtherName] = useState('');
  const [otherPrice, setOtherPrice] = useState('');

  const handleKey = useCallback((e) => {
    if (e.key === 'Escape') onClose();
  }, [onClose]);

  useEffect(() => {
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [handleKey]);

  const addCatalogItem = (item) => {
    const catDef = catalog[cat];
    if (catDef.sized) {
      onAdd({
        kind: 'catalog',
        cat,
        name: item.name,
        sized: true,
        sizes: item.sizes,
        size,
        unit: item.unit,
        qty: 1,
        catalogId: item.id,
      });
    } else {
      onAdd({
        kind: 'catalog',
        cat,
        name: item.name,
        price: item.price,
        unit: item.unit,
        qty: 1,
        catalogId: item.id,
      });
    }
  };

  const addOther = () => {
    if (!otherName.trim() || !otherPrice) return;
    onAdd({
      kind: 'custom',
      cat: 'other',
      name: otherName.trim(),
      price: parseFloat(otherPrice) || 0,
      unit: '',
      qty: 1,
    });
  };

  return (
    <div className="pos-backdrop" onClick={onClose}>
      <div className="pos-sheet" style={{ height: '82dvh' }} onClick={e => e.stopPropagation()}>
        <div className="pos-sheet-grabber" />
        <div className="pos-sheet-head">
          <h3>Agregar ítem</h3>
          <button className="pos-sheet-close" onClick={onClose}>✕</button>
        </div>

        {/* Category tabs — flex-shrink:0 per CSS gotcha */}
        <div className="pos-cat-tabs">
          {Object.entries(catalog).map(([key, c]) => (
            <button
              key={key}
              className={`pos-cat-tab${cat === key ? ' active' : ''}`}
              onClick={() => setCat(key)}
            >
              <span className="pos-ct-ic">{c.icon}</span>
              <span className="pos-ct-lbl">{c.label}</span>
            </button>
          ))}
        </div>

        {/* Hotel size selector — flex-shrink:0 per CSS gotcha */}
        {cat === 'hotel' && (
          <>
            <div className="pos-size-label">Tamaño del perro</div>
            <div className="pos-size-pick">
              {['S', 'M', 'L', 'XL'].map(s => (
                <button
                  key={s}
                  className={`pos-size-btn${size === s ? ' active' : ''}`}
                  onClick={() => setSize(s)}
                >
                  <span className="pos-size-name">{SIZE_NAMES[s]}</span>
                  <span className="pos-size-range">{SIZE_RANGES[s]}</span>
                </button>
              ))}
            </div>
          </>
        )}

        {/* Catalog items list */}
        {cat !== 'other' && (
          <div className="pos-cat-items">
            {(catalog[cat]?.items || []).map(item => {
              const price = catalog[cat].sized ? item.sizes[size] : item.price;
              return (
                <div key={item.id} className="pos-cat-item" onClick={() => addCatalogItem(item)}>
                  <div className="pos-cat-item-icon">{catalog[cat].icon}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="pos-cat-item-name">{item.name}</div>
                    <div className="pos-cat-item-note">{item.note || item.unit}</div>
                  </div>
                  <div className="pos-cat-item-price">
                    {ILS(price)}
                    <small className="pos-cat-item-unit">{item.unit}</small>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Other / custom item */}
        {cat === 'other' && (
          <div className="pos-other-form">
            <div className="pos-field">
              <label>Descripción</label>
              <input
                placeholder="ej. Correa de repuesto"
                value={otherName}
                onChange={e => setOtherName(e.target.value)}
              />
            </div>
            <div className="pos-field">
              <label>Precio ($)</label>
              <input
                type="number"
                placeholder="0"
                value={otherPrice}
                onChange={e => setOtherPrice(e.target.value)}
              />
            </div>
            <button
              className="pos-confirm-btn"
              onClick={addOther}
              disabled={!otherName.trim() || !otherPrice}
            >
              Agregar ítem
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
